export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_UPDATE_LOG_ALL: function DEVICE_UPDATE_LOG_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device-update-log/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_UPDATE_LOG_CREATE: function DEVICE_UPDATE_LOG_CREATE(data) {
      return request({
        url: '/api/device-update-log/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_UPDATE_LOG_DETAIL: function DEVICE_UPDATE_LOG_DETAIL(id) {
      return request({
        url: '/api/device-update-log/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_UPDATE_LOG_UPDATE: function DEVICE_UPDATE_LOG_UPDATE(data) {
      return request({
        url: '/api/device-update-log/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_UPDATE_LOG_DELETE: function DEVICE_UPDATE_LOG_DELETE(id) {
      return request({
        url: '/api/device-update-log/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    DEVICE_UPDATE_LOG_SYNC: function DEVICE_UPDATE_LOG_SYNC(data) {
      return request({
        url: '/api/device-update-log/sync',
        method: 'post',
        data: data
      });
    }
  };
});